// anchorPoints — конвертация 3D-точек контура грани в локальные 2D-координаты
// плоскости эскиза. Используется для snap'а при рисовании.
//
// planeRef.points3d — массив [[x,y,z], ...] (углы грани в мире).
// Возвращает [{x, y}, ...] в системе координат, совпадающей с локальным
// базисом эскиза (как в SketchOverlay.planeQuaternion).

export function getSketchAnchorPoints(planeRef) {
    if (!planeRef || !planeRef.points3d || planeRef.points3d.length === 0) return [];
    const plane = planeRef.plane;
    const pts = planeRef.points3d;

    if (plane === 'XY') {
        return pts.map(([x, y]) => ({ x, y }));
    }
    if (plane === 'XZ') {
        // sketchOnPlane('XZ') использует базис xDir=(1,0,0), yDir=(0,0,1).
        // Точки: (x_world, z_world). Y игнорируем (это offset плоскости).
        return pts.map(([x, , z]) => ({ x, y: z }));
    }
    if (plane === 'YZ') {
        // sketchOnPlane('YZ'): xDir=(0,1,0), yDir=(0,0,1).
        return pts.map(([, y, z]) => ({ x: y, y: z }));
    }
    if (plane === 'CUSTOM' && planeRef.origin && planeRef.xDir && planeRef.normal) {
        // Произвольная плоскость: проецируем 3D-точки на локальные xDir/yDir.
        // yDir = normal × xDir (правая система — как в replicad Plane).
        const o = planeRef.origin;
        const xd = planeRef.xDir;
        const n = planeRef.normal;
        const yd = [
            n[1] * xd[2] - n[2] * xd[1],
            n[2] * xd[0] - n[0] * xd[2],
            n[0] * xd[1] - n[1] * xd[0],
        ];
        return pts.map((p) => {
            const dx = p[0] - o[0];
            const dy = p[1] - o[1];
            const dz = p[2] - o[2];
            return {
                x: dx * xd[0] + dy * xd[1] + dz * xd[2],
                y: dx * yd[0] + dy * yd[1] + dz * yd[2],
            };
        });
    }
    return [];
}


/**
 * Найти ближайшую якорную точку к (x, y) в пределах threshold.
 * Возвращает {x, y, dist} или null если ничего близко.
 */
export function findNearestAnchor(anchors, x, y, threshold) {
    if (!anchors || anchors.length === 0) return null;
    let best = null;
    for (const a of anchors) {
        const dx = a.x - x;
        const dy = a.y - y;
        const d = Math.sqrt(dx * dx + dy * dy);
        if (d <= threshold && (!best || d < best.dist)) {
            best = { x: a.x, y: a.y, dist: d };
        }
    }
    return best;
}
